import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type CurrencyCode from '@alltrails/types/CurrencyCode';

const currencyCodeSlice = createSlice({
  name: 'currencyCode',
  initialState: '',
  reducers: {
    setCurrencyCode: (_, action: PayloadAction<CurrencyCode>) => {
      return action.payload;
    }
  }
});

export const { setCurrencyCode } = currencyCodeSlice.actions;

export default currencyCodeSlice.reducer;
